export const mediaMixin = {
  data() {
    return {
      formatImgUrl: (url, width) => {
        const items = url.split('/');
        return `http://res.cloudinary.com/menud/image/upload/c_scale,dpr_1.0/c_scale,w_${width}/${
          items[items.length - 1]
        }`;
      },
    };
  },
  methods: {
    $_transformCloudinaryImg(url, width = 500) {
      return this.formatImgUrl(url, width);
    },
  },
};
